<template>
  <div class="fi-plan-board" :class="{ 'fi-plan-board--horizon': horizonNavActive }" style="margin:20px">

    <FiPageRail title="Planned - Vehicle Utilization Daily" />

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>
    <div v-if="!loading && items_full.length > 0" style="font-size: 18px; font-weight: bold; margin-top: 25px" class="d-flex align-items-center justify-content-center">
      <span style="float: left; border-radius: 5px; padding: 8px; border: 1px solid grey;">Filtered: {{items.length}}<br/>Total: {{summary.total_cnt}}</span>
      &nbsp;&nbsp;&nbsp;
      <span style="float: left; border-radius: 5px; padding: 8px; border: 1px solid grey;">Assigned: {{bus_cnt}}<br/>Unassigned: {{unassigned_cnt}}</span>
      &nbsp;&nbsp;&nbsp;&nbsp;
      Types:&nbsp;<b-form-select :select-size="2" multiple v-model="selected_booking_type" :options="booking_type_options" style="font-size: 16px; width:130px"/>
      &nbsp;&nbsp;
      Veh Types:&nbsp;<b-form-select :select-size="3" multiple v-model="selected_vehicle_type" :options="vehicle_type_options" style="font-size: 16px; width:150px"/>
      &nbsp;&nbsp;
      Seats:&nbsp;<b-form-select :select-size="3" multiple v-model="selected_vehicle_seats" :options="vehicle_seats_options" style="font-size: 16px; width:80px"/>
      &nbsp;&nbsp;
      Start:&nbsp;<b-form-select :select-size="3" multiple v-model="selected_start_base" :options="start_base_options" style="font-size: 16px; width:180px"/>
      &nbsp;&nbsp;
      Finish:&nbsp;<b-form-select :select-size="3" multiple v-model="selected_finish_base" :options="finish_base_options" style="font-size: 16px; width:180px"/>
      &nbsp;&nbsp;<b-form-input style="width: 100px" v-model="search_filter" placeholder="filter"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="reset_filters()">Reset</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <table v-if="items_full.length > 0" width="100%" border='1' cellpadding='0' cellspacing="0">
        <thead>
        <tr>
          <th colspan="15">&nbsp;</th>
          <th v-if="!vehicle_status_disabled">&nbsp;</th>
          <th style='background-color: #ddd;' colspan="24">{{this.details_fromDate}}</th>
        </tr>
        <tr>
          <th width="80px" @click="sort_strings('vehicle')">Vehicle</th>
          <th width="80px" @click="sort_strings('vehicle_type')">Veh Type</th>
          <th width="90px" @click="sort_numbers('seats')">Seats</th>
          <th width="80px" @click="sort_strings('type')">Type</th>
          <th width="80px" @click="sort_strings('drivers')">Drivers</th>
          <th width="70px" @click="sort_numbers('charterIDs')">BookingID</th>
          <th width="80px" @click="sort_numbers('movementIDs')">Mvmt</th>
          <th width="80px" @click="sort_strings('first_start_base')">Start Base</th>
          <th width="80px" @click="sort_strings('last_finish_base')">Finish Base</th>
          <th width="90px" v-if="!vehicle_status_disabled" @click="sort_strings('vehicle_status')">Status</th>
          <th width="80px" @click="sort_strings('first_pickup')">Pickup</th>
          <th width="80px" @click="sort_strings('last_destination')">Destination</th>
          <th width="100px" @click="sort_dates('start_datetime')">Yard Time</th>
          <th width="100px" @click="sort_dates('position_datetime')">Spot Time</th>
          <th width="100px" @click="sort_dates('back_datetime')">Back Time</th>
          <th width="100px" @click="sort_dates('finish_datetime')">Finish Time</th>
          <th width="15px" style="background-color: #ddd; font-size: 12px; font-weight: bold" v-for="hour in hours_display">{{hour}}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{ item.vehicle | trim(12)}}</td>
            <td>{{item.vehicle_type}}</td>
            <td>{{item.seats}}/{{item.actual_seats}}</td>
            <td>{{item.type | trim(3)}}</td>
            <td>{{ item.drivers | trim(10)}}</td>
            <td>
              <span v-if="item.charterIDs && item.charterIDs.includes(',')" style="font-weight: bold">+{{item.charterIDs.split(',')[0]}}</span>
              <span v-else>{{item.charterIDs}}</span>
            </td>
            <td>
              <span v-if="item.movementIDs && item.movementIDs.includes(',')" style="font-weight: bold">+{{item.movementIDs.split(',')[0]}}</span>
              <span v-else>{{item.movementIDs}}</span>
            </td>
            <td>{{item.first_start_base}}</td>
            <td>{{item.last_finish_base}}</td>
            <td v-if="!vehicle_status_disabled">{{item.vehicle_status}}</td>
            <td>{{item.first_pickup | trim(15)}}</td>
            <td>{{item.last_destination | trim(15)}}</td>
            <td>{{item.start_datetime | formatDateTimeSmall}}</td>
            <td>{{item.position_datetime | formatDateTimeSmall}}</td>
            <td>{{item.back_datetime | formatDateTimeSmall}}</td>
            <td>{{item.finish_datetime | formatDateTimeSmall}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,15)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,30)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,45)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,60)'>&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr v-if="item.isMvmtsVisible" v-for="movement in item.movements">
            <td colspan="3" align="right" style="font-weight: bold"></td>
            <td>{{movement.type | trim(1)}}</td>
            <td>{{movement.driver | trim(10)}}</td>
            <td><router-link :to="{ path: '/actuals?booking_id=' + movement.charterID}">{{ movement.charterID }}</router-link></td>
            <td><router-link :to="{ path: '/actuals?booking_id=' + movement.booking_id}">{{ movement.movementID }}</router-link></td>
            <td>{{ movement.start_base }}</td>
            <td>{{ movement.finish_base }}</td>
            <td v-if="!vehicle_status_disabled">{{item.vehicle_status}}</td>
            <td>{{ movement.pickup | trim(15) }}</td>
            <td>{{movement.destination | trim(15) }}</td>
            <td>{{movement.start_datetime | formatDateTimeSmall}}</td>
            <td>{{movement.position_datetime | formatDateTimeSmall}}</td>
            <td>{{movement.back_datetime | formatDateTimeSmall}}</td>
            <td>{{movement.finish_datetime | formatDateTimeSmall}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style="getStyleForMvmt(details_fromDate,hour,movement,15,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,movement,30,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,movement,45,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,movement,60,'lightgreen')">&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {delete_booking, get_vehicle_utilization} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import horizonNav from '@/nav/horizon_nav_mixin'

export default {
  name: 'planned_vehicle_daily',

  mixins: [horizonNav],

  components: {
  },

  data() {
    return {
      vehicle_status_disabled: false,
      items: [],
      items_full: [],
      reloading: false,
      reload_mode: 0,
      timer: null,
      selected_vehicle_status: [],
      selected_booking_type: [],
      selected_vehicle_type: [],
      selected_vehicle_seats: [],
      selected_start_base: [],
      selected_finish_base: [],
      search_filter: '',
      summary: [],
      hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      hours_display: ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'],
      quarters: [0,15,30,45],
      loading: false,
      details_fromDate: justDate(moment()),
      vehicle_type_options: [],
      vehicle_seats_options: [],
      start_base_options: [],
      finish_base_options: [],
      booking_type_options: [
        { value: 'private_hire', text: 'Private' },
        { value: 'contract', text: 'Contract' }
      ],
      status_options: [
        { value: 'READY', text: 'Ready' },
        { value: 'CLEANED', text: 'Cleaned' },
        { value: 'WASHED', text: 'Washed' },
        { value: 'DIRTY', text: 'Dirty' },
        { value: 'OUT', text: 'Out' },
        { value: 'OOS', text: 'OOS' },
      ],
      reload_options: [
        { value: 0, text: 'OFF' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
    this.load_data()
  },
  // beforeDestroy() {
  //   clearInterval(this.timer)
  // },
  methods: {
    async check_features() {
      this.vehicle_status_disabled = !this.user.features[this.user.tenant].vehicle_status_management_enabled
    },
    async reset_filters() {
      this.selected_booking_type = []
      this.selected_vehicle_type = []
      this.selected_vehicle_seats = []
      this.selected_start_base = []
      this.selected_finish_base = []
      this.search_filter = ''
    },
    async load_data() {
      this.loading = true
      try {
        this.sort_col = 'vehicle'

        const { value: { data = [] }} = await get_vehicle_utilization(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.vehicle_type_options = data.summary.vehicle_types
        this.vehicle_seats_options = data.summary.vehicle_seats
        this.start_base_options = data.summary.start_bases
        this.finish_base_options = data.summary.finish_bases
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    hide_result(hide_item) {
      this.items = this.items.filter(item => item.row_id != hide_item.row_id)
    },
    delete_item(delete_item) {
      if(confirm("Do you really want to delete booking: " + delete_item.booking_id + "?")) {
        delete_booking(this.user.tenant, delete_item.booking_id)
        this.load_data()
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    getStyleForMvmt(fromDate,hour,mvmt,minutes,color) {
      let slice_found = false;
      let fromDateObj = moment(fromDate,'MM-DD-YYYY')

      let start_date = moment(mvmt.start_date,'MM-DD-YYYY')
      let finish_date = moment(mvmt.finish_date,'MM-DD-YYYY')

      let start_hour = parseInt(mvmt.start_hour)
      let start_min = parseInt(mvmt.start_min)
      let finish_hour = parseInt(mvmt.finish_hour)
      let finish_min = parseInt(mvmt.finish_min)

      //console.log("checking: " + fromDate + ":" + hour + ":" + minutes + " against " + mvmt.start_date + ":" + start_hour + ":" + start_min + " - " + mvmt.finish_date + ":" + finish_hour + ":" + finish_min);

      if (start_date < fromDateObj && fromDateObj < finish_date) {
        slice_found = true;
      }
      else if (start_date < fromDateObj && finish_date >= fromDateObj) {
        if (hour < finish_hour || (hour == finish_hour && finish_min >= minutes )) {
          slice_found = true;
        }
      }
      else if (finish_date > fromDateObj && start_date <= fromDateObj) {
        if (start_hour < hour || (hour == start_hour && start_min <= minutes )) {
          slice_found = true;
        }
      }
      else if (start_date <= fromDateObj && fromDateObj <= finish_date) {

        //console.log("partial day found: " + hour + "," + start_hour + ":" + finish_hour);

        if (start_hour == finish_hour && start_min == finish_min) {
          //console.log("start == finish");
        }
        else if (start_hour < hour && hour < finish_hour) {
          //console.log("complete hour found");
          slice_found = true;
        }
        else if (start_hour <= hour && hour <= finish_hour) {
          //console.log("partial hour found: " + hour);
          if (start_hour == hour && start_min <= minutes) {
            //console.log("start minute found");
            slice_found = true;
          }
          else if (finish_hour == hour && finish_min >= minutes) {
            //console.log("finish minute found");
            slice_found = true;
          }
        }
      }

      if (slice_found)
        return 'background-color:' + color
      else
        return ''
    },
    getStyleForVeh(fromDate,hour,item,minutes) {
      for (const mvmt of item.movements) {
        let resp = this.getStyleForMvmt(fromDate, hour, mvmt, minutes,'green');
        if (resp != '')
          return resp;
      }
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    filter_items() {
      this.items = this.items_full

      if (this.search_filter)
        this.items = this.items.filter(item => this.contains(item.vehicle, this.search_filter) || this.contains(item.charterIDs, this.search_filter) || this.contains(item.movementIDs, this.search_filter))
      if (this.selected_booking_type.length > 0)
        this.items = this.items.filter(item => this.selected_booking_type.includes(item.type))
      if (this.selected_vehicle_type.length > 0) {
        this.items = this.items.filter(item => this.selected_vehicle_type.includes(item.vehicle_type))
      }
      if (this.selected_vehicle_seats.length > 0)
        this.items = this.items.filter(item => (this.selected_vehicle_seats.includes(item.seats) || this.selected_vehicle_seats.includes(item.actual_seats)))
      if (this.selected_start_base.length > 0)
        this.items = this.items.filter(item => this.selected_start_base.includes(item.first_start_base))
      if (this.selected_finish_base.length > 0)
        this.items = this.items.filter(item => this.selected_finish_base.includes(item.last_finish_base))
      if (this.selected_vehicle_status.length > 0)
        this.items = this.items.filter(item => this.selected_vehicle_status.includes(item.vehicle_status))
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    bus_cnt() {
      return this.items.filter(item => item.charterIDs && item.vehicle.indexOf("CM-") == -1).length
    },
    unassigned_cnt() {
      return this.items.filter(item => item.vehicle.indexOf("CM-") != -1).length
    }

  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
        this.reset_filters()
        this.load_data()
      }
    },
    search_filter(val) {
      this.filter_items()
    },
    selected_booking_type(val) {
      this.filter_items()
    },
    selected_vehicle_type(val) {
      this.filter_items()
    },
    selected_vehicle_seats(val) {
      this.filter_items()
    },
    selected_start_base(val) {
      this.filter_items()
    },
    selected_finish_base(val) {
      this.filter_items()
    },
    selected_vehicle_status(val) {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.load_data();
    },
  }
}
</script>
<style scoped>

/* FI-2174: sticky on <thead>, not on th. this header is two rows (the blank
   spacer + date banner above the column labels) and a blanket `th { top: 0 }`
   pinned both rows to the same offset, stacking them on top of each other. */
thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

thead th {
  background-color: #F9F8F8;
  border: 1px solid black;
}

/* the horizon/midnight shell's top bar is position: fixed, so a header stuck
   at top: 0 slides underneath it. classic has no fixed chrome, so it keeps 0. */
.fi-plan-board--horizon thead {
  top: var(--fi-hz-top-offset, 52px);
}

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
a {color: darkred}
</style>


